import React from "react";

//App
import BaseChip from "./BaseChip";
import { ChipProps } from "../../../../types";

const Chip: React.FC<ChipProps> = (props) => {
    const { label, style } = props;
    var colortext: string
    var backgroundcolor: string
    switch (label) {
        case "Serviced":
        case "Active":
        case "Completed":
            colortext = "#565523";
            backgroundcolor = "#D6DCA1";
            break;
        case "Draft":
        case "Inactive":
            colortext = "#555A63";
            backgroundcolor = "#E6E7E9";
            break;
        case "Submitted":
        case "Re-Submitted":
        case "Resubmitted":
        case "Pending":
        case "Scheduled":
            colortext = "#1F5758";
            backgroundcolor = "#D9EDED";
            break;
        case "Action Required":
        case "Locked Out":
        case "Revisions Requested":
            colortext = "#76481C";
            backgroundcolor = "#F2E4D7";
            break;
        case "Processing":
        case "Awaiting Review":
            colortext = "#4E2E56";
            backgroundcolor = "#D5C6DB";
            break;
        case "Currently Serving":
            colortext = "#505523";
            backgroundcolor = "#D6DCA1";
            break;
        default:
            return null;
    }

    return <BaseChip label={label} style={style} colortext={colortext} backgroundcolor={backgroundcolor} />
};

export default Chip;
